import React from "react";
import { IoClose } from "react-icons/io5";
import { resolveMediaUrl } from "../../../../utility/media";
import { formatCurrency } from "../../../../utility/formatCurrency";
import { useTranslation } from "react-i18next";

const ViewTechnicalSanctionDetailsModal = ({ isOpen, onClose, plan }) => {
    const {t} = useTranslation();

    if (!isOpen || !plan) return null;

    return (
        <div className="staff-modal-overlay">
            <div className="staff-modal" style={{ width: '900px', maxWidth: '95%' }}>
                {/* Modal Header matching establish style */}
                <div className="staff-modal-header" style={{ background: '#a0adf1', borderBottom: '1px solid #979797' }}>
                    <div className="staff-modal-title" style={{ color: 'white', width: '100%', textAlign: 'center' }}>
                        {t('pageTitles.technicalSanctionDetails')}
                    </div>
                    <button className="staff-modal-close" onClick={onClose} style={{ color: 'white' }}>
                        <IoClose />
                    </button>
                </div>

                <div className="staff-form-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    
                    {/* 1. Primary Plan Information (Read-Only) */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 mt-2 px-4 border-b pb-4 text-sm">
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap" style={{ marginBottom: 0 }}>{t('tables.workName')} :</label>
                            <span className="font-bold text-gray-800">{plan.nameOfWork || "N/A"}</span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap" style={{ marginBottom: 0 }}>{t('tables.location')} :</label>
                            <span className="text-gray-700">{plan.districtName || "N/A"}</span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap" style={{ marginBottom: 0 }}>{t('tables.workType')} :</label>
                            <span className="text-gray-700">{plan.workTypeName || "N/A"}</span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap" style={{ marginBottom: 0 }}>{t('tables.estimateCost')} :</label>
                            <span className="font-bold text-gray-600">₹ {formatCurrency(plan.estimateCost || '')}</span>
                        </div>
                    </div>

                    {/* 2. Admin Sanction Info (Previously Approved Stage) */}
                    <div className="bg-blue-50/30 p-4 mx-4 rounded-lg border border-blue-100 grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 text-sm">
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap text-blue-800 font-bold" style={{ marginBottom: 0 }}>{t('forms.technicalSanction.adminSanctionCost')} :</label>
                            <span className="font-bold text-blue-700">₹ {formatCurrency(plan.adminCost) || "N/A"}</span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap text-blue-800 font-bold" style={{ marginBottom: 0 }}>{t('forms.technicalSanction.adminSanctionDate')} :</label>
                            <span className="text-gray-800">{plan.adminDate || "N/A"}</span>
                        </div>
                    </div>

                    {/* 3. Technical Sanction Specific Info (Current Stage) */}
                    <div className="bg-green-50/50 p-4 mx-4 rounded-lg border border-green-100 grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 text-sm">
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap text-green-800 font-bold" style={{ marginBottom: 0 }}>
                                {t('forms.technicalSanction.sanctionCost')} :
                            </label>
                            <span className="font-bold text-green-700">
                                ₹ {formatCurrency(plan.technicalCost) || "Pending"}
                            </span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap text-green-800 font-bold" style={{ marginBottom: 0 }}>
                                {t('forms.technicalSanction.sanctionDate')} :
                            </label>
                            <span className="font-bold text-gray-800">
                                {plan.technicalDate || "Pending"}
                            </span>
                        </div>
                    </div>

                    {/* Attachments Table */}
                    <div className="border border-black rounded-sm overflow-hidden mx-auto mb-4" style={{ width: '95%' }}>
                        <table className="w-full text-sm border-collapse">
                            <thead>
                                <tr className="bg-gray-100 border-b border-black">
                                    <th className="p-2 text-center border-r border-black font-bold w-12">{t('tables.srNo')}</th>
                                    <th className="p-2 border-r border-black font-bold">{t('tables.attachmentDesc')}</th>
                                    <th className="p-2 text-center font-bold w-48">{t('tables.file')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {plan.attachmentData && plan.attachmentData.length > 0 ? (
                                    plan.attachmentData.map((item, index) => (
                                        <tr key={item.id || index} className="border-b border-black last:border-0">
                                            <td className="p-2 text-center border-r border-black">{index + 1}</td>
                                            <td className="p-2 pl-4 text-left border-r border-black whitespace-pre-wrap">
                                                {item.description}
                                            </td>
                                            <td className="p-2 text-center">
                                                {item.attachmentUrl ? (
                                                    <a 
                                                        href={resolveMediaUrl(item.attachmentUrl)} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        className="text-blue-600 underline hover:text-blue-800 break-all"
                                                    >
                                                        {item.attachmentName || "View File"}
                                                    </a>
                                                ) : (
                                                    <span className="text-gray-400 italic">{t('common.noAttachment')}</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="p-4 text-center text-gray-500 italic">
                                            {t('common.noAttachment')}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="staff-form-footer">
                    <button className="staff-btn-save" onClick={onClose}>
                        {t('common.close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewTechnicalSanctionDetailsModal;